export default function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">{children}</h2>
  );
}
